// frontend/src/components/claims/STEPS.js

export const STEPS = [
  { key: 'basics',    label: 'Patient & Basics',  icon: 'user', errorPrefixes: [
    'patient', 'patient_id', 'patient_account_number', 'patient_relationship_to_insured',
    'place_of_service', 'claim_frequency_code', 'original_reference_number',
  ]},
  { key: 'insurance', label: 'Insurance & Payer', icon: 'credit-card', errorPrefixes: [
    'insured', 'payer', 'payer_snapshot',
    'claim_filing_indicator', 'prior_authorization_number',
  ]},
  // Validator emits the canonical wire field names with `_snapshot` suffix
  // (billing_provider_snapshot.npi, service_facility_snapshot.npi, etc.).
  // Prefix matching is exact-or-startsWith — without the suffix variants,
  // Provider-step errors fall through and Continue silently advances.
  { key: 'provider',  label: 'Provider',          icon: 'briefcase-medical', errorPrefixes: [
    'billing_provider', 'billing_provider_snapshot',
    'service_facility', 'service_facility_snapshot',
    'rendering_provider', 'referring_provider',
  ]},
  { key: 'services',  label: 'Services',          icon: 'list-checks', errorPrefixes: [
    'diagnoses', 'service_lines',
  ]},
  { key: 'docs',      label: 'Documents',         icon: 'paperclip', errorPrefixes: [] },
  { key: 'review',    label: 'Review & Submit',   icon: 'send', errorPrefixes: [] },
];

/** @param {string} key */
export function findStepIndexByKey(key) {
  return STEPS.findIndex((s) => s.key === key);
}

/**
 * Normalize bracket notation (service_lines[0].x) to dot notation (service_lines.0.x)
 * so prefix matching works uniformly with what indexValidationErrors emits.
 * @param {string|undefined|null} field
 * @param {string} prefix
 */
function fieldMatchesPrefix(field, prefix) {
  if (!field) return false;
  const normalized = String(field).replace(/\[(\d+)\]/g, '.$1');
  return normalized === prefix || normalized.startsWith(prefix + '.');
}

/**
 * Resolve the step index that owns a given field path. Returns -1 if no step
 * claims it (e.g. a top-level field like `version` or an error from a future
 * unmapped section). Callers use that as "no jump available".
 * @param {string|undefined|null} field
 */
export function findStepIndexByField(field) {
  if (!field) return -1;
  for (let i = 0; i < STEPS.length; i++) {
    for (const p of STEPS[i].errorPrefixes) {
      if (fieldMatchesPrefix(field, p)) return i;
    }
  }
  return -1;
}

/**
 * Count how many errors in a flat list belong to a given step.
 * @param {Array<{field?: string|null}>} errors
 * @param {{ errorPrefixes: string[] }} step
 */
export function countErrorsForStep(errors, step) {
  let n = 0;
  for (const e of errors || []) {
    for (const p of step.errorPrefixes) {
      if (fieldMatchesPrefix(e.field, p)) { n++; break; }
    }
  }
  return n;
}
